export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/company_skus/state.js